import { render, staticRenderFns } from "./Forwarder.vue?vue&type=template&id=3a050074&scoped=true&"
import script from "./Forwarder.vue?vue&type=script&lang=js&"
export * from "./Forwarder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a050074",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nicholashaskell/Local/kicknic/app/public/wp-content/themes/kicknic/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a050074')) {
      api.createRecord('3a050074', component.options)
    } else {
      api.reload('3a050074', component.options)
    }
    module.hot.accept("./Forwarder.vue?vue&type=template&id=3a050074&scoped=true&", function () {
      api.rerender('3a050074', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/scripts/components/panels/Forwarder.vue"
export default component.exports